import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, SupportedLanguage } from '../i18n';
import styles from './LanguageSwitcher.module.css';

/**
 * Compact EN / العربية toggle for the header.
 *
 * Persists the chosen language via i18next's localStorage detector
 * (key: `aitp.lang`) so the choice survives reloads. The
 * `languageChanged` listener in `src/i18n/index.ts` mirrors the value
 * onto <html lang> and <html dir> so RTL styles flip automatically.
 */
const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const current = (i18n.resolvedLanguage || i18n.language || 'en').slice(0, 2) as SupportedLanguage;

  const handleChange = (lng: SupportedLanguage) => {
    if (lng === current) return;
    void i18n.changeLanguage(lng);
  };

  return (
    <div className={styles.container} role="group" aria-label={t('language.label')}>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`${styles.button} ${current === lng ? styles.buttonActive : ''}`}
          onClick={() => handleChange(lng)}
          aria-pressed={current === lng}
          lang={lng}
        >
          {lng === 'en' ? t('language.english') : t('language.arabic')}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
